import { inject } from "@angular/core";
import { type CanActivateFn, Router} from "@angular/router";
import { AuthStore } from "../services/auth.store";

/**
 * Stops the user from accessing the route if not logged in
 * Returns the user to the login page if not logged in, with a returnUrl query param to redirect back after successful login
 */
export const authGuard: CanActivateFn = async (_route, state) => {
  const router = inject(Router);
  const authStore = inject(AuthStore);

  if (!authStore.isInitialized()) return false;

  if (authStore.isLoggedIn()) return true;

  return router.createUrlTree(['/login'], {
    queryParams: {
      returnUrl: state.url
    }
  });
};
